import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { ProvinceTaskAction, ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask, ProvinceTaskAttachment } from '@/store/provinceTask/provinceTask.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProvinceTaskAttachmentModelComponent',
  components: {
    BaseModalComponent
  },
  props: {
    provinceTaskId: {
      type: Number,
    }
  },
  emits: [
    'upload',
    'hidden',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const provinceTask = computed<ProvinceTask>(() => store.getters[ProvinceTaskGetter.BY_ID](props.provinceTaskId));
    const attachments = computed<ProvinceTaskAttachment[]>(() => (provinceTask.value) ? provinceTask.value?.provinceTaskAttachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[ProvinceTaskGetter.STATUS] === 'init' || store.getters[ProvinceTaskGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', provinceTask.value?.id);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProvinceTaskAction.REMOVE_ATTACHMENTS, {
              id: provinceTask.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    // hidden
    const handleHidden = () => {
      context.emit('hidden', provinceTask.value?.id);
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
      handleHidden,
    };
  },
});
